// extracted by mini-css-extract-plugin
export default {"reviews":"eF","yotpo":"fF","wrapper":"gF","review_list":"hF","carousel":"iF","swiper-slide":"jF","review":"kF","title":"lF","verified":"mF"};
    if(module.hot) {
      // 1743628927155
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  